import { Injectable, inject } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FileUploadCategory} from "../interfaces/file-upload-category";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private http = inject(HttpClient);


  uploadImage(file: File, category: string ) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category); // optional

    return this.http.post(environment.backendApi+'/api/upload/', formData);
  }

  getPresignedUrl(key: string) {
    return this.http.post(environment.backendApi+`/api/presigned-url/`, {key});
  }
}
